import { components } from "react-select";
import PropTypes from "prop-types";

const MenuList = ({ children, ...props }) => (
	<components.MenuList className="advanced-select-menu-list" {...props}>
		<div
			className="advanced-select-menu-list__container"
			data-interacted={props.selectProps?.hasInteracted || undefined}
			onMouseMove={props.selectProps?.onOptionsMouseMove}
			onMouseLeave={props.selectProps?.onOptionsMouseLeave}
		>
			{children}
		</div>
	</components.MenuList>
);

MenuList.propTypes = {
	selectProps: PropTypes.object,
};

export default MenuList;
